import React from 'react';
import { Tooltip , Popover } from 'antd';
import utils from '../../../utils';
import fetch from '../../fetch';

const DataGrid = {
    selections: [],
    refresh: function () {

    }
}

const setRefresh = (callback) => {
    DataGrid.refresh = callback
}


const onSelect = (ids) => {
    DataGrid.selections = ids
}

const getSelection = () => {
    return DataGrid.selections;
}

const headers = utils.columns([
    { type: 'selection' },
    {
        key: '$index',
        label: '序号',
        width: 80
    },
    {
        key: 'schoolTypeName',
        label: '学校类型',
        width: 100,
    },
    {
        key: 'cityName',
        label: '学生所属教育局',
        width: 130
    },
    {
        key: 'schoolName',
        label: '学校',
        width: 150,
        render: (data) => {
            return <Tooltip title={data}>{data}</Tooltip>
        }
    },
    {
        key: 'termName',
        label: '学期',
        width: 140
    },
])

const columnsArray = [
    { type: 'selection' },
    {
        key: '$index',
        label: '序号',
        width: 80
    },
    {
        key: 'schoolTypeName',
        label: '学校类型',
        width: 100,
    },
    {
        key: 'cityName',
        label: '学生所属教育局',
        width: 130
    },
    {
        key: 'schoolName',
        label: '学校',
        width: 150,
        render: (data) => {
            return <Tooltip title={data}>{data}</Tooltip>
        }
    },
    {
        key: 'termName',
        label: '学期',
        width: 140
    },
]

const querySearch = (keywords = { pageNum: 1, pageSize: 100 }) => {
    let params = []
    if (keywords['sort'] !== '$index') {
        for (var i in keywords) {
            if (i === 'order') {
                params.push(`order=${keywords[i]}`)
            }
            if (i === 'sort') {
                params.push(`sort=${keywords[i]}`)
            }
        }
    }
    params.push(`pageNum=${keywords.pageNum}`)
    params.push(`pageSize=${keywords.pageSize}`)
    return fetch.post('survey/statistics/surveygraduatequery?' + params.join('&'), keywords)
        .then((response) => {
            let newArray = []
            let choices = response.payload.meta.extParams.choices;
            for (let i = 0; i < columnsArray.length; i++) {
                if (i === 5) {
                    if(choices){
                        choices.forEach((choice , index) => {
                            newArray.push({
                                key : `choiceCount${index+1}`,
                                label: <div className=''>{`${choice}评价数`}</div>,
                                width: 170 ,
                                render: (data) => {
                                    return <Tooltip title={choice}>{data}</Tooltip>
                                }
                            })
                            newArray.push({
                                key : `choiceTotalCount${index+1}`,
                                label: <div className=''>{`${choice}样本数`}</div>,
                                width: 170 ,
                                render: (data) => {
                                    return <Tooltip title={choice}>{data}</Tooltip>
                                }
                            })
                            const content = (
                                <div>
                                      <p style={{color : 'red'}}>毕业生满意度调查问卷应覆盖20%以上的 2023 年应届全日制毕业生和已毕业三年内的全日制毕业生</p>
                                </div>
                            )
                            const title = <div style={{fontSize : 16 ,fontWeight: 'bold'}}>调查问卷回收要求</div>
                            newArray.push({
                                key : `choicePercent${index+1}`,
                                label:  <Popover content={content} title={title}>
                                <div className=''>{`${choice}完成率%`}</div></Popover>,
                                width: 175 ,
                                render: (data) => {
                                    return <Tooltip title={choice}>{data}</Tooltip>
                                }
                            })
                        });
                    }
                }
                newArray.push(columnsArray[i])
            }
            if (response.code === 200) {
                return {
                    data: response.payload.data,
                    headers: utils.columns(newArray.length > 0 ? newArray : columnsArray)
                }
            }
        }).then(res => (
            Object.assign({
                headers: res.headers,
                result: res.data.dataList || [],
                selects: (res.data.dataList || []).map(d => ({
                    value: d.schoolId,
                    checked: false
                })),
                checked: false,
                total: res.data.total,
                pageIndex: res.data.pageNum,
                pageSize: res.data.pageSize,
                notify: (res.data.dataList || []).length ? '' : '暂无数据...'
            }))
        )
}

export default {
    setRefresh,
    onSelect,
    getSelection,
    headers,
    querySearch
}